"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdKeyboardArrowLeft = require("@react-icons/all-files/md/MdKeyboardArrowLeft");

var _MdKeyboardArrowRight = require("@react-icons/all-files/md/MdKeyboardArrowRight");

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _ContentBox = require("./ContentBox.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ContentBox = function ContentBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      expandFromTitle = _ref.expandFromTitle,
      _ref$initiallyCollaps = _ref.initiallyCollapsed,
      initiallyCollapsed = _ref$initiallyCollaps === void 0 ? true : _ref$initiallyCollaps,
      _ref$expandText = _ref.expandText,
      expandText = _ref$expandText === void 0 ? 'Expand' : _ref$expandText,
      _ref$fadeWhenCollapse = _ref.fadeWhenCollapsed,
      fadeWhenCollapsed = _ref$fadeWhenCollapse === void 0 ? true : _ref$fadeWhenCollapse,
      _ref$plain = _ref.plain,
      plain = _ref$plain === void 0 ? false : _ref$plain,
      title = _ref.title;
  var wrapperRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(initiallyCollapsed),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isCollapsed = _useState2[0],
      setIsCollapsed = _useState2[1];

  var toggleCollapse = function toggleCollapse(event) {
    if (event.target.tagName === 'H2') {
      if (!expandFromTitle || !isCollapsed) {
        return false;
      }
    }

    wrapperRef.current.scrollTop = 0;
    return setIsCollapsed(!isCollapsed);
  };

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isContentAtTop = _useState4[0],
      setIsContentAtTop = _useState4[1];

  var toggleContentAtTop = function toggleContentAtTop() {
    setIsContentAtTop(wrapperRef.current.scrollTop === 0);
  };

  (0, _react.useEffect)(function () {
    var throttled = (0, _throttle["default"])(toggleContentAtTop, 100);
    wrapperRef.current.addEventListener('scroll', throttled);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledContentBox, {
    className: className,
    isCollapsed: isCollapsed,
    plain: plain
  }, !isCollapsed && !plain && /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledContentBoxBack, {
    role: "presentation",
    isContentAtTop: isContentAtTop
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: toggleCollapse
  }, /*#__PURE__*/_react["default"].createElement(_MdKeyboardArrowLeft.MdKeyboardArrowLeft, null), "Back")), /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledContentBoxWrapper, {
    ref: wrapperRef,
    isCollapsed: isCollapsed,
    plain: plain
  }, title && /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledContentBoxTitle, {
    expandFromTitle: expandFromTitle,
    isCollapsed: isCollapsed,
    onClick: toggleCollapse
  }, title, expandFromTitle && isCollapsed && /*#__PURE__*/_react["default"].createElement(_MdKeyboardArrowRight.MdKeyboardArrowRight, null)), /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledContentBoxContent, {
    isCollapsed: isCollapsed,
    fadeWhenCollapsed: fadeWhenCollapsed,
    hasTitle: !!title,
    plain: plain
  }, children), !plain && isCollapsed && /*#__PURE__*/_react["default"].createElement(_ContentBox.StyledExpandContentBox, null, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: toggleCollapse
  }, expandText))));
};

ContentBox.defaultProps = {
  children: undefined,
  className: '',
  expandFromTitle: false,
  expandText: 'Expand',
  fadeWhenCollapsed: true,
  initiallyCollapsed: true,
  plain: false,
  title: undefined
};
ContentBox.propTypes = {
  /** Content box contents */
  children: _propTypes.node,

  /** Custom class to be added to the content box container */
  className: _propTypes.string,

  /** If true, clicking on the title will expand its content. (mobile-only) */
  expandFromTitle: _propTypes.bool,

  /** Text for the click to expand action */
  expandText: _propTypes.string,

  /** Fade the wrapper content when collapsed */
  fadeWhenCollapsed: _propTypes.bool,

  /** Initially show collapsed box */
  initiallyCollapsed: _propTypes.bool,

  /** Vanilla flavor. Just a plain and simple empty content box */
  plain: _propTypes.bool,

  /** Title of the content box */
  title: _propTypes.string
};
ContentBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentBox",
  "props": {
    "initiallyCollapsed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Initially show collapsed box",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "expandText": {
      "defaultValue": {
        "value": "'Expand'",
        "computed": false
      },
      "description": "Text for the click to expand action",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fadeWhenCollapsed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Fade the wrapper content when collapsed",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "plain": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Vanilla flavor. Just a plain and simple empty content box",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Content box contents",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom class to be added to the content box container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "expandFromTitle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, clicking on the title will expand its content. (mobile-only)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Title of the content box",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = ContentBox;
exports["default"] = _default;